module.exports = __webpack_public_path__ + "media/images/admin/icons/chevrons-right-675f5302ca57b814609822c480de79f1.svg";